const Donate = ({title, url, newTab}) => {
	return (
		<div className="mt-8">
			<a href={url} className="text-sky-400 font-semibold" {  ...(newTab && { target: "_blank" } )} rel="noreferrer">{ title }</a>
		</div>
	);
}
 
export default Donate;